var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "shopReviewThanks" }, [
    _c("div", { staticClass: "shopReviewThanks__container" }, [
      _c("div", { staticClass: "shopReviewThanks__header" }, [
        _c("img", {
          attrs: {
            src: _vm.imageUrl("/not_found_concierge_logo.png"),
            alt: "コンシェルジュロゴ",
          },
        }),
        _vm._v(" "),
        _c("h1", [_vm._v("口コミの投稿が完了しました")]),
        _vm._v(" "),
        _c("span", [_vm._v("口コミをご投稿いただきありがとうございます。")]),
        _vm._v(" "),
        _c("span", [
          _vm._v("ご投稿いただいた口コミは、審査後数日以内に反映されます。"),
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "/" } }, [_vm._v("▶トップページへ")]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }